export const FireBaseConfig = {
  apiKey: "AIzaSyCz3twutQM_oSg7LVIRZ_BHLTX_EVWPWAw",
  authDomain: "https://chicken-station-bnei-brak.firebaseio.com/",
  databaseURL: "https://chicken-station-bnei-brak.firebaseio.com/",
  projectId: "https://chicken-station-bnei-brak.firebaseio.com/",
  storageBucket: "chicken-station-bnei-brak.appspot.com",
  messagingSenderId: "432502650216"
};
